import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { DataListingProviderComponent } from '../../../../shared/components/data-listing-provider/data-listing-provider.component';
import { AuthenticationGuard } from '../../../../shared/guard/authentication-guard';
import { HasUnsavedChangesGuard } from '../../../../shared/guard/has-form-changed.guard';
import { Entity, HeaderMenuType } from '../../../../shared/store/view/types';
import { ModuleId } from '../../../../shared/store/navigation/types';
import { CommissionPlanRuleDetailsComponent } from '../commission-plan-rule-details/commission-plan-rule-details.component';
import { CommissionPlanRuleSalesPersonCreateComponent } from '../commission-plan-rule-sales-person/commission-plan-rule-sales-person-create/commission-plan-rule-sales-person-create.component';
import { CommissionPlanRuleSalesPersonEditComponent } from '../commission-plan-rule-sales-person/commission-plan-rule-sales-person-edit/commission-plan-rule-sales-person-edit.component';
import { CommissionPlanRuleSharedSalesPersonEditComponent } from './commission-plan-rule-shared-sales-person-edit/commission-plan-rule-shared-sales-person-edit.component';
import { CommissionPlanRuleSharedSalesPersonCreateComponent } from './commission-plan-rule-shared-sales-person-create/commission-plan-rule-shared-sales-person-create.component';

const routes: Routes = [
  {
    path: 'Finance/CommissionPlanRuleSharedSalesPersons',
    data: {
      breadcrumb: { label: ' ', alias: 'list' },
    },
    children: [
      {
        path: '',
        redirectTo: 'List',
        pathMatch: 'full',
      },
      {
        path: 'List',
        component: DataListingProviderComponent,
        canActivate: [AuthenticationGuard],
        canDeactivate: [HasUnsavedChangesGuard],
        data: {
          headerMenu: HeaderMenuType.Finance,
          moduleId: ModuleId.finance,
          entity: Entity.CommissionPlanRuleSharedSalesPerson,
          breadcrumb: { skip: true },
        },
      },
      {
        path: 'Details/:id',
        component: CommissionPlanRuleDetailsComponent,
        canActivate: [AuthenticationGuard],
        canDeactivate: [HasUnsavedChangesGuard],
        data: {
          headerMenu: HeaderMenuType.Finance,
          moduleId: ModuleId.finance,
          entity: Entity.CommissionPlanRuleSharedSalesPerson,
          breadcrumb: {
            label: ' ',
            alias: 'commissionPlanRuleDetails',
          },
        },
      },
      {
        path: 'Create',
        component: CommissionPlanRuleSharedSalesPersonCreateComponent,
        canActivate: [AuthenticationGuard],
        canDeactivate: [HasUnsavedChangesGuard],
        data: {
          headerMenu: HeaderMenuType.Finance,
          moduleId: ModuleId.finance,
          entity: Entity.CommissionPlanRuleSharedSalesPerson,
          breadcrumb: {
            label: ' ',
            alias: 'commissionPlanRuleSharedSalesPersonCreate',
          },
        },
      },
      {
        path: 'Edit/:id',
        component: CommissionPlanRuleSharedSalesPersonEditComponent,
        canActivate: [AuthenticationGuard],
        canDeactivate: [HasUnsavedChangesGuard],
        data: {
          headerMenu: HeaderMenuType.Finance,
          moduleId: ModuleId.finance,
          entity: Entity.CommissionPlanRuleSharedSalesPerson,
          breadcrumb: {
            label: ' ',
            alias: 'commissionPlanRuleSharedSalesPersonEdit',
          },
        },
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class CommissionPlanRuleSharedSalesPersonRoutingModule {}
